import React, { Component, type ReactElement } from 'react';
import { styled } from '@compiled/react';
import { Radio as AkRadio } from '@atlaskit/radio';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import type { VersionId } from '../../../../common/model/index.tsx';
import { MOVE, DELETE } from '../../../model/operation.tsx';
import type { Operation } from '../../../model/types.tsx';
import messages from './messages.tsx';

export type VersionPickerProps = {
	onChange: (
		arg1:
			| {
					id: VersionId;
					name: string;
			  }
			| undefined,
	) => void;
};

type RenderVersionPicker = (arg1: VersionPickerProps) => ReactElement;

type Props = {
	isDisabled: boolean;
	renderVersionPicker: RenderVersionPicker;
	operation: Operation;
	onOperationChanged: (arg1: Operation) => void;
	onTargetVersionChanged: (arg1: VersionId | undefined) => void;
	intl: IntlShape;
};

// eslint-disable-next-line jira/react/no-class-components
export class MoveVersion extends Component<Props> {
	onMoveSelected = (): void => {
		this.props.onOperationChanged(MOVE);
	};

	onDeleteSelected = (): void => {
		this.props.onOperationChanged(DELETE);
	};

	onVersionPicked = (version?: { id: VersionId; name: string }): void => {
		this.props.onTargetVersionChanged(version ? version.id : undefined);
	};

	render(): React.JSX.Element {
		const {
			intl: { formatMessage },
			renderVersionPicker,
			operation,
			isDisabled,
		} = this.props;

		return (
			<div>
				<AkRadio
					isChecked={operation === MOVE}
					onChange={this.onMoveSelected}
					isDisabled={isDisabled}
					label={formatMessage(
						fg('jira-issue-terminology-refresh-m3')
							? messages.moveIssuesIssueTermRefresh
							: messages.moveIssues,
					)}
					testId="version-modals.delete-version.content.move-version.move-radio"
				/>
				<PickerContainer>{renderVersionPicker({ onChange: this.onVersionPicked })}</PickerContainer>
				<AkRadio
					isChecked={operation === DELETE}
					onChange={this.onDeleteSelected}
					isDisabled={isDisabled}
					label={formatMessage(messages.removeVersion)}
					testId="version-modals.delete-version.content.move-version.remove-radio"
				/>
			</div>
		);
	}
}

export default injectIntl(MoveVersion);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PickerContainer = styled.div({
	width: '300px',
	marginTop: token('space.050'),
	marginRight: 0,
	marginBottom: token('space.200'),
	marginLeft: token('space.300'),
});
